import { Component, EventEmitter, OnInit } from "@angular/core";
import { ProjectView, ProjectViewHelper } from "@app/project/model/project-view";
import { map, take } from "rxjs/operators";

import { MatDialog } from "@angular/material/dialog";
import { AuthUser } from "@app/auth/model/auth-user";
import { ProjectViewDispatchers } from "@app/project/store/dispatchers/project-view.dispatchers";
import { Observable } from "rxjs";
import { EditProjectViewComponent } from "../edit-project-view/edit-project-view.component";

@Component({
    selector: "app-project-views-container",
    templateUrl: "./project-views-container.component.html",
})
export class ProjectViewsContainerComponent implements OnInit {
    // Need to be supplied from wherever the component is being initialized
    // This object will update as it is mutated, which is fine since we cannot bind it as Inputs
    public config: {
        entityId: number;
        userId: number;
        authUser?: AuthUser;
        projectViewChange?: EventEmitter<ProjectView>;
    };

    public activeViewId$: Observable<number>;
    public allViews$: Observable<ProjectView[]>;

    constructor(private readonly projectViewDispatcher: ProjectViewDispatchers, private readonly dialog: MatDialog) {}

    ngOnInit(): void {
        const defaultView = ProjectViewHelper.getDefaultViewForRole(this.config.authUser);
        this.allViews$ = this.projectViewDispatcher.getProjectViewsArray().pipe(
            map(projectViews => {
                const index = projectViews.findIndex(view => view.id === defaultView.id);
                if (index === -1) {
                    projectViews.unshift(defaultView);
                }
                return projectViews.sort((a, b) => a.name.localeCompare(b.name));
            })
        );

        this.activeViewId$ = this.projectViewDispatcher.getActiveProjectView$().pipe(map(activeView => activeView?.id || null));
    }

    editProjectView(projectView: ProjectView) {
        const dialogRef = this.dialog.open(EditProjectViewComponent, { maxHeight: "100vh" });
        // DDB-4487: the max height modifier for the case we would support the mobile view list customization
        dialogRef.componentInstance.projectView = projectView;
        dialogRef.componentInstance.entityId = this.config.entityId;
        dialogRef.componentInstance.userId = this.config.userId;
        dialogRef.componentInstance.closeEditProjectView.pipe(take(1)).subscribe(_ => this.dialog.closeAll());
        dialogRef.componentInstance.authUser = this.config.authUser;

        return dialogRef;
    }

    projectViewChange(projectView: ProjectView) {
        this.projectViewDispatcher.dispatchUpdateProjectViewSuccessAction(projectView);
    }
}
